import { ArticleHeading3, Body2 } from '@cian/ui-kit/typography';

import type { ITechRow, ITechSection } from 'shared/utils/buildingDetails';

import style from './style.css';

export interface IBuildingTechProps {
  section: ITechSection;
  /** Якорь `#tech` — только при блоке «Технические характеристики», как в монолите */
  isTechVisible: boolean;
}

const TechRows = ({ rows, isNameBold }: { rows: ITechRow[]; isNameBold: boolean }) => (
  <>
    {rows.map(({ name, value }) => (
      <div key={name} className={style['row']}>
        <dt>
          <Body2 fontWeight={isNameBold ? 'bold' : undefined}>{name}</Body2>
        </dt>
        <dd className={style['value']}>
          <Body2>{value}</Body2>
        </dd>
      </div>
    ))}
  </>
);

/** Нижняя секция карточки: «Арендаторы» и «Технические характеристики» (`cf-bsc-detail-footer` монолита) */
export const BuildingTech = ({ section, isTechVisible }: IBuildingTechProps) => {
  const { tenants, tech } = section;

  return (
    <section className={style['container']} id={isTechVisible ? 'tech' : undefined} data-name="BuildingTech">
      <div className={style['content']}>
        {tenants && (
          <div className={style['block']}>
            <ArticleHeading3 as="h2">Арендаторы</ArticleHeading3>
            <Body2 as="p">{tenants}</Body2>
          </div>
        )}
        {tech && (
          <div className={style['block']}>
            <div className={style['tech-title']}>
              <ArticleHeading3 as="h2">Технические характеристики</ArticleHeading3>
            </div>
            {tech.groups.length > 0 && (
              <dl className={style['groups']}>
                {tech.groups.map((group, index) => (
                  <div key={index} className={style['group']} data-name="BuildingTechGroup">
                    <TechRows rows={group} isNameBold />
                  </div>
                ))}
              </dl>
            )}
            {tech.electricity && (
              <>
                <div className={style['subtitle']}>
                  <Body2 as="h3" fontWeight="bold">
                    Электроснабжение
                  </Body2>
                </div>
                <dl className={style['group']}>
                  {/* Как `prop-list_sub` монолита: названия обычным */}
                  <TechRows rows={tech.electricity} isNameBold={false} />
                </dl>
              </>
            )}
          </div>
        )}
      </div>
    </section>
  );
};
